import { getAnncouncement, getAnncouncementDetail, getAnncouncementParams} from 'src/api/Admin'
import { useAdRecruitStore } from 'src/stores/AdRecruitStore'

export interface RecruitScheduleData{
    announce_id : number
    title: string
    recruitment_type: string
    created_at: string 
    application_sdate: string
    application_edate: string
    completion_date : string // 선발 완료일
    calculated_status: string
    etc : Schedule[]
}

export const LoadRecruitSchedule = async (params:getAnncouncementParams)=>{
    const response = await getAnncouncement(params)
    
    return {
        data: response.data as RecruitScheduleData[],
        totalPage: response.total_pages,
    };
}

export type Schedule = {
    course_name: string;
    start_date: string; // ISO date string
    end_date: string;   // ISO date string
};

export interface RecruteDetailData{
    announce_id: number,
    title: string,
    recruitment_type: string,
    requirements: string,
    source_url: string,
    application_sdate: string,
    application_edate: string,
    enlistment_date: string,
    appointment_date: string,
    schedules: Schedule[]
    created_at: string
    updated_at: string
}

export const LoadRecruteDetail = async (announce_id : number) : Promise<RecruteDetailData> =>{
    const response = await getAnncouncementDetail(announce_id)
    return response.data as RecruteDetailData
}

export const useFetchRecruitSchedule = () => {
    const setField= useAdRecruitStore((state)=>state.setField); // store에서 필요한 상태 가져오기
    const type = useAdRecruitStore((state)=>state.type)
    const sort_by = useAdRecruitStore((state)=>state.sort_by)
    const sort_order = useAdRecruitStore((state)=>state.sort_order)
    const page = useAdRecruitStore((state)=>state.page)
    const pageSize = useAdRecruitStore((state)=>state.pageSize)
    const status = useAdRecruitStore((state)=>state.status)
    const fetchData = async () => {
            const result = await LoadRecruitSchedule(
                { 
                    recruitmentType : type,
                    status : status,
                    sort_by : sort_by,
                    sort_order : sort_order,
                    page : page,
                    size : pageSize
                }
            );
        setField('recruitScheduleData', result.data);
        setField('totalPage', result.totalPage);
    };

    return { fetchData };
};